const types = {
  GET_ORDER_DETAILS_START: 'GET_ORDER_DETAILS_START',
  GET_ORDER_DETAILS_SUCCESS: 'GET_ORDER_DETAILS_SUCCESS',
  GET_ORDER_DETAILS_FAILURE: 'GET_ORDER_DETAILS_FAILURE',
};

export default types;
